import React from 'react';

import { useRoutes } from '../../config/routes';
// Direct import (not the pages barrel) so this eager 404 fallback doesn't pull
// every route page into the initial bundle — see config/lazyPages.js.
import { NotFoundPage } from '../../pages/NotFoundPage';

/**
 * Walk the user's route table along a chain of paths, e.g.
 * ['/portfolio', '/portfolio/holdings'], and return the matching node.
 */
const resolveNode = (routes, chain) => {
  let candidates = routes;
  let node = null;

  for (const path of chain) {
    node = candidates?.find((route) => route.path === path);
    if (!node) return null;
    candidates = node.routes;
  }

  return node;
};

/**
 * Renders one route from the router's static tree.
 *
 * The tree is built once, from every route that can exist for any user, because
 * React Router v7 creates its router outside React. Access is therefore decided
 * here instead: we look the route up in `useRoutes()`, which is the same
 * per-user table the menus are built from. A route the current user has no
 * access to simply isn't in that table, so it renders the 404 page — the same
 * thing that happened before the migration, when such routes were left out of
 * the route list entirely. That keeps gated pages unreachable even when their
 * URL is typed directly.
 *
 * Resolving against the live table also means the page still receives its own
 * config (title, icon, sub-routes) as props, so the menus keep working exactly
 * as they did.
 */
export const RouteElement = ({ chain }) => {
  const routes = useRoutes();
  const node = resolveNode(routes, chain);

  if (!node) return <NotFoundPage />;

  const { component: Component } = node;

  return <Component {...node} />;
};
